import type {
  ArticleObject,
  CreateArticlePayload,
  UpdateArticlePayload,
  GetUserArticles,
  GetUserArticlesResponse,
} from 'commons/types';
import {
  articlesTypes,
  otherUserArticlesTypes,
  createArticleTypes,
  updateArticleTypes,
  autoSaveArticleTypes,
} from './types';

export const usersArticlesActions = {
  clickLetsGo: (): {
    type: string;
  } => ({
    type: articlesTypes.LETS_GO_CLICK,
  }),
  clickPublish: (): {
    type: string;
  } => ({
    type: articlesTypes.PUBLISH_CLICK,
  }),
  getUserArticles: (payload: GetUserArticles) => ({
    type: articlesTypes.REQUEST,
    payload,
  }),
  getUserArticlesSuccess: (
    { articles, count }: GetUserArticlesResponse,
    currentPage: number,
    articleType: string,
  ) => ({
    type: articlesTypes.SUCCESS,
    payload: {
      articles,
      count,
      currentPage,
      articleType,
    },
  }),
  getUserArticlesFailed: (error: string, articleType: string) => ({
    type: articlesTypes.FAILED,
    payload: {
      error,
      articleType,
    },
  }),
  getUserArticle: (articleId: string) => ({
    type: articlesTypes.REQUEST_BY_ID,
    payload: articleId,
  }),
  getUserArticleSuccess: (article: ArticleObject) => ({
    type: articlesTypes.SUCCESS_BY_ID,
    payload: article,
  }),
  getUserArticleFailed: (error: string) => ({
    type: articlesTypes.FAILED_BY_ID,
    payload: error,
  }),
  resetCurrentArticle: () => ({
    type: articlesTypes.RESET_CURRENT,
  }),
  getOtherUserArticlesRequest: (payload: number) => ({
    type: otherUserArticlesTypes.REQUEST,
    payload,
  }),
  getOtherUserArticlesSuccess: (
    { articles, count }: GetUserArticlesResponse,
    currentPage: number,
  ) => ({
    type: otherUserArticlesTypes.SUCCESS,
    payload: {
      articles,
      count,
      currentPage,
    },
  }),
  getOtherUserArticlesFailed: (error: string) => ({
    type: otherUserArticlesTypes.FAILED,
    payload: error,
  }),
  createArticleRequest: (payload: CreateArticlePayload) => ({
    type: createArticleTypes.REQUEST,
    payload,
  }),
  createArticleSuccess: (articleCreated: ArticleObject) => ({
    type: createArticleTypes.SUCCESS,
    payload: articleCreated,
  }),
  createArticleFailed: (error: string) => ({
    type: createArticleTypes.FAILED,
    payload: error,
  }),
  setCurrentDraftArticle: (payload: ArticleObject) => ({
    type: articlesTypes.SET_CURRENT_DRAFT,
    payload,
  }),
  updateArticleRequest: (payload: UpdateArticlePayload) => ({
    type: updateArticleTypes.REQUEST,
    payload,
  }),
  updateArticleSuccess: (articleUpdated: ArticleObject | null) => ({
    type: updateArticleTypes.SUCCESS,
    payload: articleUpdated,
  }),
  updateArticleFailed: (error: string) => ({
    type: updateArticleTypes.FAILED,
    payload: error,
  }),
  performAutoSaveRequest: (payload: UpdateArticlePayload) => ({
    type: autoSaveArticleTypes.REQUEST,
    payload,
  }),
  performAutoSaveSuccess: (articleUpdated: ArticleObject) => ({
    type: autoSaveArticleTypes.SUCCESS,
    payload: articleUpdated,
  }),
  performAutoSaveFailed: (error: string) => ({
    type: autoSaveArticleTypes.FAILED,
    payload: error,
  }),
};
